import { createAction, props } from '@ngrx/store';
import { AppCountry } from '../../app.models';
import { MgError } from 'src/app/models/error.model';
import { CountriesRequest } from './countries.model';

export enum CountriesActions {
  getCountries = '[Countries] getCountries',
  getCountriesSuccess = '[Countries] getCountriesSuccess',
  getCountriesFailed = '[Countries] getCountriesFailed',
  setSelectedCountry = '[Countries] setSelectedCountry',
  clearCountriesData = '[Countries] clearCountriesData',
}

export const GetCountries = createAction(
  CountriesActions.getCountries,
  props<{ getCountriesRequest: CountriesRequest }>()
);

export const GetCountriesSuccess = createAction(
  CountriesActions.getCountriesSuccess,
  props<{ countriesResponse: any }>()
);

export const GetCountriesFailed = createAction(
  CountriesActions.getCountriesFailed,
  props<{ payload: { error: MgError; countries: AppCountry[] } }>()
);

export const SetSelectedCountry = createAction(
  CountriesActions.setSelectedCountry,
  props<{ selectedCountry: string }>()
);

export const ClearCountriesDataAction = createAction(
  CountriesActions.clearCountriesData
);
